import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { MediaFile } from '../types';

@customElement('list-view')
export class GalleryListView extends LitElement {
  static readonly styles = css`
    :host {
    }

    .table {
      width: 100%;
      border-collapse: collapse;
    }

    .table__thead {
      background-color: #f5f5f5;
    }

    .table__row {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .table__cell {
      padding: 8px;
      border: 1px solid #ccc;
      box-sizing: border-box;
      width: 100%;
      flex: 1;
      display: flex;
    }

    .table__tbody {
      display: flex;
      flex-direction: column;
    }

    .table__tbody .table__row {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  `;

  @property({ type: Array })
  files: MediaFile[] = [];

  render() {
    return html`
      <table class="table">
        <thead class="table__thead">
          <tr class="table__row">
            <th class="table__cell">Name</th>
            <th class="table__cell">Size</th>
            <th class="table__cell">Type</th>
          </tr>
        </thead>
        <tbody class="table__tbody">
          ${this.files.map(
            file => html`
              <tr class="table__row">
                <td class="table__cell">${file.name}</td>
                <td class="table__cell">${file.size}</td>
                <td class="table__cell">${file.mime}</td>
              </tr>
            `
          )}
        </tbody>
      </table>
    `;
  }
}
